<template>
  <button
    class="toggle-sidebar"
    type="button"
    @click="toggleSidebarVisible"
  >
    <ion-icon name="menu-outline"></ion-icon>
  </button>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'ToggleSidebar',

  methods: {
    ...mapMutations('dashboard', [
      'toggleSidebarVisible',
    ]),
  },
};
</script>

<style lang="scss" scoped>
  .toggle-sidebar {
    @apply text-gray-600;
    border: none;
    outline: none;
    font-size: 1.875rem;
    height: 35px;

    &:hover {
      @apply text-gray-800;
    }
  }
</style>
